module.exports = __webpack_public_path__ + "img/Mstorybg8.90c9ddbe.jpg";